<template>
	<div>
		<TopHeader :tabIndex='3'></TopHeader>
		<div class="cont">
			<div class="flex flex-b">
				<Breadcrumb :pathList="pathList"></Breadcrumb>
				<div class="search flex">
					<img src="../../assets/icon/search.png" style="width: 16px;height: 16px;" alt="" />
					<input type="text" v-model="keyword" placeholder="搜索课程" @keyup.enter="getTrainOrderList()">
				</div>
			</div>
			<div class="flex-only" style="margin-top: 30px;">
				<div class="tit">分类标签</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex1==0?'active':''" @click="changeType(0)">全部</div>
					<div class="item pointer" v-for="(item,index) in trainCateList"
						:class="tabIndex1==index+1?'active':''" @click="changeType(item,index)">{{item.name}}</div>
				</div>
			</div>
			<div class="flex-only" style="margin-top: 10px;">
				<div class="tit">培训状态</div>
				<div class="flex flex-1 flex-wrap">
					<div class="item pointer" :class="tabIndex2==0?'active':''" @click="changeStatus(0)">全部</div>
					<div class="item pointer" v-for="(item,index) in stausList" :class="tabIndex2==index+1?'active':''"
						@click="changeStatus(item,index)">{{item}}</div>
				</div>
			</div>
			<div class="result">共找到 <span>{{this.trainList.length}}</span> 门课程</div>

			<div class="flex flex-wrap">
				<div class="itembg1 pointer" v-for="item in trainList">
					<div class="rel" @click="toTarinDetail(item)">
						<img :src="item.img" style="width: 100%;height: 228px;border-radius: 13px;" />
						<div class="status" v-if="item.status==1">报名中</div>
						<div class="status status2" v-if="item.status==2">进行中</div>
						<div class="status status3" v-if="item.status==3">已结束</div>
						<div class="tip">{{item.train_cate_name}}</div>
					</div>
					<div class="ititle">{{item.name}}</div>
					<div class="flex mt10">
						<img src="../../assets/images/icon/irl.png" style="width: 13px;height: 13px;" />
						<div class="time">{{item.begin_time}} 至 {{item.end_time}}</div>
					</div>
					<div class="flex mt10">
						<img src="../../assets/images/icon/idz.png" style="width: 13px;height: 13px;" />
						<div class="time">{{item.address}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 10px;">
						<div class="price flex" v-if="item.pay_type==1">¥{{item.price}}</div>
						<div class="price flex" v-if="item.pay_type==2">{{item.score}}积分</div>
						<div class="price flex" v-if="item.pay_type==3">0</div>
						<div class="flex" @click="cancle(item)" v-if="item.status==1">
							<img src="../../assets/images/mine/cancle.png"
								style="width: 18px;height: 18px;margin-left: 7px;">
							<div class="cancle">取消报名</div>
						</div>
					</div>
				</div>
			</div>

			<pagination :total="trainCount" :page_size="page_size" @currentChange='currentChange'></pagination>
		</div>
		<el-dialog :visible.sync="showCancle" width="360px" :close-on-click-modal='false' :show-close="false"
			:close-on-press-escape='false'>
			<div class="cancleBox flex-column-item">
				<div class="tit">取消报名请电联</div>
				<div class="number">{{phoneNumber}}</div>
				<div class="wxbtn pointer" @click="showCancle=false">我知道了</div>
			</div>
		</el-dialog>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getTrainCate,
		getTrainOrderList
	} from "@/api/train";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Pagination from '../../components/Pagination.vue';
	import toTop from '../../components/toTop.vue'
	import Breadcrumb from '../../components/Breadcrumb.vue'
	export default {
		components: {
			TopHeader,
			Footer,
			Pagination,
			toTop,
			Breadcrumb,

		},
		data() {
			return {
				tabIndex1: 0,
				tabIndex2: 0,
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '我的培训',
					path: ''
				}],
				stausList: ['报名中', '进行中', '已结束'],
				showCancle: false,
				trainCateList: [], //分类列表
				trainList: [],
				phoneNumber: '', //取消电话号码
				keyword: '',
				trainCount: 0,
				page_size: 12,
				page_index: 1
			}
		},
		mounted() {
			this.getTrainCate()
			this.getTrainOrderList()
		},
		methods: {
			cancle(item) {
				this.showCancle = true
				this.phoneNumber = item.cancel_phone
			},
			toTarinDetail(item) {
				this.$router.push({
					path: '/myTrainingDetail',
					query: {
						id: item.uuid,
					}
				})
			},
			changeType(item, index) {
				if (item == 0) {
					this.tabIndex1 = 0
					this.id = ''
					this.getTrainOrderList()
					return
				}
				this.tabIndex1 = index + 1
				this.id = item.uuid
				this.getTrainOrderList()
			},
			changeStatus(item, index) {
				if (item == 0) {
					this.tabIndex2 = 0
					this.status = ''
					this.getTrainOrderList()
					return
				}
				this.tabIndex2 = index + 1
				this.getTrainOrderList()
			},
			async getTrainCate() {
				const {
					status,
					data
				} = await getTrainCate({})
				this.trainCateList = data.result
			},
			async getTrainOrderList() {
				const {
					status,
					data
				} = await getTrainOrderList({
					train_cate_uuid: this.id,
					status: this.tabIndex2,
					keyword: this.keyword,
					page_index: this.page_index,
					page_size: this.page_size
				})
				this.trainList = data.result.data
				this.trainCount = data.result.total
			},
			//改变页数
			currentChange(e) {
				this.page_index = e
				this.getTrainOrderList()
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.cont {
		padding: 30px 133px 0;

		.title {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 27px;
			color: #000000;
		}

		.search {
			height: 40px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			input {
				margin-left: 10px;
				border: none;
				background-color: transparent;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333;

				&:focus {
					outline: none;
				}
			}
		}

		.tit {
			width: 7%;
			line-height: 36px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.item {
			margin: 0 20px 14px 0;
			height: 36px;
			padding: 0 14px;
			background: #FFFFFF;
			border-radius: 9px 9px 9px 9px;
			border: 1px solid #EEEEEE;
			opacity: 0.8;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 36px;
		}

		.active {
			height: 36px;
			border: 1px solid rgba(0, 167, 60, 0.06);
			background: rgba(0, 167, 60, 0.06);
			border-radius: 9px 9px 9px 9px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #00A73C;
			line-height: 36px;
		}

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.itembg1 {
			width: calc(33% - 27px);
			margin-right: 27px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px;
			position: relative;
			margin-bottom: 20px;

			&:nth-child(3n) {
				margin-right: 0;
			}

			.rel {
				position: relative;
				border-radius: 13px;
				overflow: hidden;

				.status {
					position: absolute;
					right: 0;
					top: 0;
					height: 22px;
					background: #00A73C;
					border-radius: 0px 13px 0px 9px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
					line-height: 22px;
					padding: 0 10px;

					&.status2 {
						background: #D7B155;
					}

					&.status3 {
						background: #FC5F5F;
					}
				}

				.tip {
					position: absolute;
					left: 10px;
					bottom: 10px;
					height: 22px;
					line-height: 22px;
					padding: 0 10px;
					background: rgba(0, 0, 0, 0.4);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
				}
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
			}

			.mt10 {
				margin-top: 10px;
			}

			.time {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.price {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #00A73C;
			}

			.cancle {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FC5F5F;
			}
		}
	}

	::v-deep .el-dialog__header {
		display: none;
	}

	.cancleBox {
		.tit {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}

		.number {
			margin: 20px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
		}

		.wxbtn {
			width: 298px;
			height: 40px;
			border-radius: 12px 12px 12px 12px;
			border: 2px solid rgba(127, 218, 76, .24);
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
</style>